import { JsonObject, JsonProperty } from 'json2typescript';
import { StatusResultInterface } from '../interfaces/status-result.interface';

@JsonObject('StatusResultModel')
export class StatusResultModel implements StatusResultInterface {
  @JsonProperty('Status', Boolean)
  status: boolean = undefined;
}
